// @ts-strict-ignore
import { SeeqNames } from '@/main/app.constants.seeqnames';
import { SEEQ_VERSION } from '@/services/buildConstants.service';
import { logInfo } from '@/hybrid/utilities/logger';
import { reload } from '@/hybrid/utilities/utilities';
import _ from 'lodash';

/**
 * An HTTP interceptor that will inspect the 'Server' header for the Seeq version running on the server.
 * If the version doesn't match the frontend version, the frontend will perform a force reload.
 */
export function versionInterceptor(response) {
  const serverHeader = _.get(response, `headers[${SeeqNames.API.Headers.Server}]`);
  if (serverHeader && _.includes(serverHeader, 'Seeq/')) {
    // Extract only the version part of the header (also removes any extra data added by proxies, CRAB-15461)
    const serverVersion = _.replace(serverHeader, /^(.*\s)*Seeq\/(.*?)(\s.*)*$/, '$2');
    if (serverVersion !== SEEQ_VERSION) {
      // Server and client version don't match (e.g. server has been upgraded), so force a reload of the client
      logInfo(`Server and client version mismatch ('${serverVersion}' vs '${SEEQ_VERSION}'), forcing reload of client`);
      reload();
    }
  }

  return response;
}
